import { createTheme } from "@mui/material/styles";

export const createAppTheme = (isDark) =>
  createTheme({
    palette: {
      mode: isDark ? "dark" : "light",
    },
    typography: {
      fontFamily: "'DM Sans', sans-serif",
    },
  });
